import { Controller } from "@hotwired/stimulus"

// Client-side filter for the add-exercise picker. Typing in the search box hides
// non-matching exercise rows, collapses sections that end up empty, and shows a
// "no results" message when nothing matches.
export default class extends Controller {
  static targets = ["search", "item", "section", "empty"]

  filter() {
    const q = this.searchTarget.value.trim().toLowerCase()

    this.itemTargets.forEach((item) => {
      const match = q === "" || item.dataset.name.includes(q)
      item.classList.toggle("hidden", !match)
    })

    this.sectionTargets.forEach((section) => {
      const visible = section.querySelectorAll("[data-name]:not(.hidden)").length > 0
      section.classList.toggle("hidden", !visible)
    })

    if (this.hasEmptyTarget) {
      const anyVisible = this.itemTargets.some((i) => !i.classList.contains("hidden"))
      this.emptyTarget.classList.toggle("hidden", anyVisible)
    }
  }
}
